import { FormFieldTypes } from "../../../../../../../components/finalForms/libs/data/formFieldType";

const initState = {
    deferralStartDate: null,
    deferralEndDate: null,
    deferralReason: null,
  };

  export const deferralPeriodsFormConfig = {
    name: "DeferralPeriodsForm",
    initialState: initState,
    section: [
      {
        sectionId: "DeferralPeriodsForm",
        title: "DeferralPeriodsForm Details",
        row: {},
        style: {
          sectionStyle: "col-lg-12 col-md-12",
        },
        wrapperTemplate: <div className="row"></div>, // Wrapper HTML or Component
        rowGroup: [
          {
            groupLabel: "DeferralPeriodsForm Information", // Group for contact fields
            style: {
              groupStyle: "col-lg-12 col-md-12 mb-2",
            },
            fields: [
              {
                id: "deferralStartDate",
                label: "Deferral Start Date:",
                Field_Name: "Deferral Start Date",
                fieldType: FormFieldTypes.DATEPICKER,
                dataField: "deferralStartDate",
                fieldSetting: {
                  placeholder: "Enter Deferral Start Date",
                },
                validation: [{ type: "require" }],
                style: {
                  containerCss: "col-lg-12 col-md-4 col-4 mb-2 ",
                },
              },
              {
                id: "deferralEndDate",
                label: "Deferral End Date:",
                Field_Name: "Deferral End Date",
                fieldType: FormFieldTypes.DATEPICKER,
                dataField: "deferralEndDate",
                fieldSetting: {
                  placeholder: "Enter Deferral End Date",
                },
                validation: [{ type: "require" }],
                style: {
                  containerCss: "col-lg-12 col-md-4 col-4 mb-2 ",
                },
              },
              {
                id: "deferralReason",
                label: "Deferral Reason:",
                Field_Name: "Deferral Reason",
                fieldType: FormFieldTypes.INPUT,
                dataField: "deferralReason",
                fieldSetting: {
                  placeholder: "Enter Deferral Reason",
                },
                validation: [{ type: "require" }],
                style: {
                  containerCss: "col-lg-12 col-md-4 col-4 mb-2 ",
                },
              },
            ],
          },
        ],
      },
    ],
  };